import { client } from "../../../Infrastructure/agent";

export const CommercialService = {
  getAllContracts: () => client.get("/commercial/GetAllContracts"),
  getContractObligations: (year, assetId) =>
    client.post("/commercial/GetContractObligations", { year, assetId }),
  createContract: (contract) =>
    client.post("/commercial/CreateCenter", { contract }),

  save: (obligations) =>
    client.post("/commercial/SaveObligations", { obligations }),

  copy: (year, assetId) =>
    client.post("/commercial/CopyObligations", { year, assetId }),
};

